// extracted by mini-css-extract-plugin
export default {"title":"kZkiKd","form":"lC9dX_","row":"ql8HEG","rowNowrap":"txSNYP","nextButton":"Byw5j4"};